<template>
  <base-section id="features" class="secondary">
    <v-responsive class="mx-auto" max-width="1350">
      <v-container fluid>
        <h1
          class="text-uppercase headline font-weight-bold mb-2 text-center white--text"
        >
          Training courses & Workshops
        </h1>

        <v-row>
          <v-col
            v-for="card in cards"
            :key="card.title"
            cols="12"
            sm="4"
            md="3"
          >
            <base-info-card align="center" dark v-bind="card" />
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </base-section>
</template>

<script>
export default {
  name: "SectionFeatures",

  data: () => ({
    cards: [
      {
        color: "#0BA137",
        icon: "mdi-domain",
        title: "Training Care of Babies",
        text:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
      },
      {
        color: "#0BA137",
        icon: "mdi-book",
        title: "Training in Care of Babies",
        text:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
      },
      {
        color: "#0BA137",
        icon: "mdi-book",
        title: "Training in Care of Elderly or Disabled",
        text:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
      },
      {
        color: "#0BA137",
        icon: "mdi-puzzle-outline",
        title: "Training in Cooking",
        text:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
      },
      {
        color: "#0BA137",
        icon: "mdi-handshake-outline",
        title: "Training Lesson in Spoken English",
        text:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
      },
      {
        color: "#0BA137",
        icon: "mdi-google-my-business",
        title: "General Orientation for Employment as a Maid in Singapore",
        text:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
      }
    ]
  })
};
</script>
